import { Language, Translation } from './types';

export const TRANSLATIONS: Record<Language, Translation> = {
  'en-US': {
    title: 'DraftMyComplaint',
    subtitle: 'My private lab environment for complaint drafts.',
    labelSender: 'My signature (Optional)',
    phSender: '',
    labelCompany: 'Company or Authority Name',
    phCompany: 'e.g., SkyHigh Airlines, Local Municipality...',
    labelDate: 'Date of Incident (Optional)',
    labelRecipient: 'Recipient Email (Optional)',
    phRecipient: 'claims@company.com',
    labelCC: 'On Copy (CC) (Optional)',
    phCC: 'manager@company.com; lawyer@firm.com',
    labelTone: 'Tone of Voice',
    toneFormal: 'Formal & Factual',
    toneAngry: 'Angry & Disappointed',
    toneLegal: 'Strict & Legal',
    labelCompensation: 'Compensation Demand Level',
    compReasonable: 'Reasonable',
    compGoBig: 'Go Big or Go Home!',
    labelDescription: 'Incident Description',
    phDescription: 'Short description of the incident, e.g., disgusting dip sauce, smelly minced meat, or a ruined item from my latest home delivery of food.',
    labelImage: 'Upload Photo (Optional)',
    btnGenerate: 'Generate my draft',
    btnGenerating: 'Drafting...',
    previewTitle: 'Email Preview',
    btnDownload: 'Download PDF',
    btnCopy: 'Copy Text',
    btnEmail: 'Open in Email Client',
    alertCopied: 'Email text copied to clipboard!',
    errorGeneric: 'Something went wrong. Please try again.',
    errorMissingKey: 'Server configuration error.',
    companyNameError: 'Please enter the company/authority name.',
    descriptionError: 'Please describe the incident.',
    infoTitle: 'My Project: DraftMyComplaint',
    infoDesc: 'This is my personal, entirely vibe-coded page. I use AI via Google’s Gemini models to help me articulate my complaints effectively and professionally. I always believe that I deserve fair compensation for poor service or trashy products, and this tool aims to facilitate the process of creating professional and humorous complaints.',
    btnClose: 'Close',
    btnShowDetails: 'Show Optional Fields (Date, Email, Photos)',
    btnHideDetails: 'Hide Optional Fields',
  },
  'sv-SE': {
    title: 'DraftMyComplaint',
    subtitle: 'Min privata lab-miljö för reklamationsutkast.',
    labelSender: 'Min signatur (valfritt)',
    phSender: '',
    labelCompany: 'Företag eller Myndighet',
    phCompany: 't.ex. SJ, Elgiganten, Flygbolag...',
    labelDate: 'Datum för händelse (Valfritt)',
    labelRecipient: 'Mottagarens E-post (Valfritt)',
    phRecipient: 'kundtjanst@foretag.se',
    labelCC: 'Kopia (CC) (Valfritt)',
    phCC: 'chef@foretag.se; jurist@byra.se',
    labelTone: 'Tonläge',
    toneFormal: 'Formell & Saklig',
    toneAngry: 'Upprörd & Förbannad',
    toneLegal: 'Juridisk & Bestämd',
    labelCompensation: 'Ersättningsnivå',
    compReasonable: 'Rimlig',
    compGoBig: 'Ingen minns en fegis!',
    labelDescription: 'Beskrivning av händelse',
    phDescription: 'Kort beskrivning av händelsen, tex äcklig dipsås, köttfärs som luktar eller förstörd vara från min senaste hemleverans av mat.',
    labelImage: 'Ladda upp bild (Valfritt)',
    btnGenerate: 'Generera mitt utkast',
    btnGenerating: 'Skapar...',
    previewTitle: 'Förhandsgranskning',
    btnDownload: 'Ladda ner PDF',
    btnCopy: 'Kopiera text',
    btnEmail: 'Öppna i mailklient',
    alertCopied: 'Mailtext kopierad till urklipp!',
    errorGeneric: 'Något gick fel. Försök igen.',
    errorMissingKey: 'Serverfel: Konfiguration saknas.',
    companyNameError: 'Vänligen ange namn på företaget/myndigheten.',
    descriptionError: 'Vänligen beskriv händelsen.',
    infoTitle: 'Mitt projekt: DraftMyComplaint',
    infoDesc: 'Detta är min personliga, helt och hållet vibekodade sida. Jag använder AI via googles geminimodeller för att hjälpa mig formulera mina klagomål effektivt och professionellt. Jag anser alltid att jag förtjänar rättvis ersättning för dålig service eller skräpiga produkter, och detta verktyg syftar till att underlätta processen att skapa professionella och humorstiska klagomål.',
    btnClose: 'Stäng',
    btnShowDetails: 'Visa valfria fält (Datum, E-post, Bilder)',
    btnHideDetails: 'Dölj valfria fält',
  }
};

export const FLAGS: Record<Language, string> = {
  'en-US': '🇺🇸',
  'sv-SE': '🇸🇪'
};